<template>
    <section class="slider">
        <div class="slider__container" ref="container">
            <div class="slider__wrapper" ref="wrapper">
                <slot />
            </div>
            <div v-if="showPrevArrow" class="slider__prev" @click.prevent="prevSlide">
                <span class="fas fa-angle-left"></span>
            </div>
            <div v-if="showNextArrow" class="slider__next" @click.prevent="nextSlide">
                <span class="fas fa-angle-right"></span>
            </div>
            <div class="slider__mobile" ref="mobile"></div>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            slide: {
                width: 0,
                space: 0,
            },
            offset: 0,
            totalSlides: 0,
            currentSlide: 0,
            sizeContainer: 0,
            isMobile: false,
        }
    },
    computed: {
        firstSlideElement: function() {
            if(this.totalSlides <= 0) return null;
            return this.$slots.default[0].elm;
        },
        showNextArrow: function() {
            if(this.currentTraslate() <= this.maxTraslate) return false;
            return true;
        },
        showPrevArrow: function() {
            if(this.currentTraslate() >= this.minTraslate) return false;
            return true;
        },
        minTraslate: function() {
            return 0;
        },
        maxTraslate: function() {
            return this.sizeContainer - this.sizeWrapper;
        },
        sizeWrapper: function() {
            return (
                (this.slide.width * this.totalSlides) +
                (this.slide.space * (this.totalSlides - 1)) +
                (this.offset * 2)
            );
        },
        sizeSlide: function() {
            return this.slide.width + this.slide.space;
        },
        slidesPerView: function() {
            return Math.floor(this.sizeContainer/this.sizeSlide);
        },
    },
    methods: {
        currentTraslate: function(slide) {
            if(!this.slide.width) return false;
            if(!slide) slide = this.currentSlide;
            let translate = (this.sizeSlide * slide * -1) + this.offset;

            if(translate >= this.minTraslate) {
                this.currentSlide = 0;
                translate = this.minTraslate;
            }
            if(translate <= this.maxTraslate) {
                // this.currentSlide = this.totalSlides - this.slidesPerView;
                translate = this.maxTraslate;
            }
            return translate;
        },
        getComputedStyles: function(element, prop) {
            if(!element) return null;
            let styles = element.currentStyle || window.getComputedStyle(element);
            if(!prop) return styles;
            let propValue = styles[prop];
            if(propValue.match(/px$/i)) {
                propValue = parseInt(propValue.replace(/px/i,''));
            }
            return propValue;
        },
        firstSlideComputedStyles: function(prop) {
            return this.getComputedStyles(this.firstSlideElement, prop);
        },
        mobileComputedStyles: function(prop) {
            return this.getComputedStyles(this.$refs.mobile, prop);
        },
        wrapperComputedStyles: function(prop) {
            return this.getComputedStyles(this.$refs.wrapper, prop);
        },
        nextSlide: function() {
            this.currentSlide++;
        },
        prevSlide: function() {
            this.currentSlide--;
        },
        preperData: function() {
            this.totalSlides = this.$slots.default ? this.$slots.default.length : 0;
            if(this.mobileComputedStyles('display') == 'none') {
                this.isMobile = false;
                this.slide.space = this.firstSlideComputedStyles('marginRight');
                this.slide.width = this.firstSlideComputedStyles('width');
                this.offset = this.wrapperComputedStyles('paddingLeft');
                this.sizeContainer = this.$refs.container.offsetWidth;
                this.$refs.wrapper.style.width = `${this.sizeWrapper}px`;
            } else {
                this.isMobile = true;
                this.$refs.wrapper.style.width = '';
                this.currentSlide = 0;
            }
        },
        changeSlide: function(slide) {
            let margin = `${this.currentTraslate(slide)}px`;
            this.firstSlideElement.style.marginLeft = margin;
        }
    },
    watch: {
        currentSlide: function (newSlide) {
            this.changeSlide(newSlide);
        }
    },
    mounted() {
        this.preperData();
        window.addEventListener('resize', this.preperData);
    },
    updated() {
        this.preperData();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.preperData);
    },
}
</script>
